module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "connect-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('connections1')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right",
    class: {
      'zh1': !_vm.isEn, 'fr1': _vm.isFr, 'cz1': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/back.png")
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('home')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _vm._l((_vm.hcpApply), function(item) {
    return _c('div', {
      staticClass: "context apply",
      attrs: {
        "id": item.uid
      }
    }, [_c('img', {
      staticClass: "hcptype",
      attrs: {
        "src": require("../../assets/Pro.png")
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "applyImg",
      attrs: {
        "src": require("../../assets/User-1.png")
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('fullName')) + ": " + _vm._s(item.realname))]), _vm._v(" "), _c('span', {
      staticClass: "applyTip"
    }, [_vm._v(_vm._s(_vm.$t('t1105_request_to_view_your_data').replace('$1', item.username)))]), _vm._v(" "), _c('div', {
      staticClass: "applyButton"
    }, [_c('button', {
      on: {
        "click": function($event) {
          _vm.open(0, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Deny')))]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.open(1, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Agree')))])]), _vm._v(" "), _c('img', {
      staticClass: "cancel",
      attrs: {
        "src": require("../../assets/cancel_black.png")
      },
      on: {
        "click": _vm.openDelete
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.carerApply), function(item) {
    return _c('div', {
      staticClass: "context apply",
      attrs: {
        "id": item.uid
      }
    }, [_c('img', {
      staticClass: "applyImg",
      attrs: {
        "src": require("../../assets/User-1.png")
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('fullName')) + ": " + _vm._s(item.realname))]), _vm._v(" "), _c('span', {
      staticClass: "applyTip"
    }, [_vm._v(_vm._s(_vm.$t('t1105_request_to_view_your_data').replace('$1', item.username)))]), _vm._v(" "), _c('div', {
      staticClass: "applyButton"
    }, [_c('button', {
      on: {
        "click": function($event) {
          _vm.open(0, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Deny')))]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.open(1, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Agree')))])]), _vm._v(" "), _c('img', {
      staticClass: "cancel",
      attrs: {
        "src": require("../../assets/cancel_black.png")
      },
      on: {
        "click": _vm.openDelete
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.hcp), function(item) {
    return _c('div', {
      staticClass: "context",
      attrs: {
        "id": item.uid
      }
    }, [_c('img', {
      staticClass: "hcptype",
      attrs: {
        "src": require("../../assets/Pro.png")
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": require("../../assets/User-1.png")
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('fullName')) + ": " + _vm._s(item.realname))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Bio')) + ": "), _c('span', [_vm._v(_vm._s(item.motto))])]), _vm._v(" "), _c('img', {
      staticClass: "cancel",
      attrs: {
        "src": require("../../assets/cancel_black.png")
      },
      on: {
        "click": _vm.openDelete
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.carer), function(item) {
    return _c('div', {
      staticClass: "context",
      attrs: {
        "id": item.uid
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/User-1.png")
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('fullName')) + ": " + _vm._s(item.realname))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Bio')) + ": "), _c('span', [_vm._v(_vm._s(item.motto))])]), _vm._v(" "), _c('img', {
      staticClass: "cancel",
      attrs: {
        "src": require("../../assets/cancel_black.png")
      },
      on: {
        "click": _vm.openDelete
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.oauth2), function(item) {
    return _c('div', {
      staticClass: "context",
      attrs: {
        "id": item.name
      }
    }, [(item.name == 'diasend') ? _c('img', {
      attrs: {
        "src": require("../../assets/diasend.png")
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../assets/User-1.png")
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p'), _vm._v(" "), _c('img', {
      staticClass: "cancel",
      attrs: {
        "src": require("../../assets/cancel_black.png")
      },
      on: {
        "click": _vm.deleteAuth
      }
    })])
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noMes),
      expression: "noMes"
    }],
    staticClass: "noMes"
  }, [_vm._v(_vm._s(_vm.$t('noConnect')))])], 2), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n         " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.ChooseVisible,
      "size": "tiny",
      "id": "dialog-form2",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.ChooseVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Warning')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/cancel.png")
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isA),
      expression: "isA"
    }]
  }, [_vm._v(_vm._s(_vm.$t('agreeConnect')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isA),
      expression: "!isA"
    }]
  }, [_vm._v(_vm._s(_vm.$t('denyConnect')))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isA),
      expression: "isA"
    }],
    on: {
      "click": _vm.agree
    }
  }, [_vm._v(_vm._s(_vm.$t('Agree')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isA),
      expression: "!isA"
    }],
    on: {
      "click": _vm.reject
    }
  }, [_vm._v(_vm._s(_vm.$t('Yes')))]), _vm._v(" "), _c('button', {
    staticClass: "cancel1",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.ChooseVisible2,
      "size": "tiny",
      "id": "dialog-form3",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.ChooseVisible2 = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Warning')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/cancel.png")
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('deleteConnect')))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.delete1
    }
  }, [_vm._v(_vm._s(_vm.$t('Delete')))]), _vm._v(" "), _c('button', {
    staticClass: "cancel1",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bdcf660"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/care-templates/patient-connect.vue
// module id = 1476
// module chunks = 7